import { useMutation } from '@apollo/client'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import LoadSxpChat from 'src/components/common/LoadSxpChat'
import { LogInTime } from 'src/services/individualService'
import Layout from 'src/components/Individual/common/Layout'

const CheckUser = () => {
  const userInfo = useSelector((state) => state?.userInfo)

  const [logInTime] = useMutation(
    LogInTime(userInfo?.userInfo?.userData?.userName)
  )
  useEffect(() => {
    logInTime()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Layout />
      <LoadSxpChat />
    </>
  )
}

export default CheckUser
